import { css, type Theme } from "@emotion/react";

export const mainWrapper = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  background-color: ${theme.system.backgroundMuted};
  border-radius: 0.5rem;
  padding: 1rem 2rem;
`;

export const mobileWrapper = css`
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem;
`;

export const subWrapper = css`
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-direction: row;
`;

export const shippingPadding = css`
  padding-left: 2rem;
`;
export const extraPadding = css`
  padding: 0 2rem;
`;
